import { Pool } from "../../../Utils/Collections/Pool";
import { Obstacle } from "./Obstacle";
import { NodeList } from "../../../Utils/Collections/NodeList";
import { Node } from "../../../Utils/Collections/Node";
import { ViewCellMapRow } from "../View/ViewCellMapRow";
import { eModelAsset, eAtlas_0, eAnimAsset } from "../../../Game";
import { ObstacleVersion, ObstacleCollisionArea, ObstacleShadow, ObstacleAnimation } from "./ObstacleVersion";
import { eObstacleType } from "./ObstacleTypes";
import { ObstacleMapData } from "./ObstacleMapData";
import { ShiftingObstacle } from "./Shifting/ShiftingObstacle";
import { FlyingObstacle } from "./Shifting/FlyingObstacle";
import { MovingObs } from "./Moving/MovingObs";
import { HammerObsVer } from "./Hammer/HammerObsVer";
import { HammerObs } from "./Hammer/HammerObs";
import { RotatorObsVer } from "./Rotator/RotatorObsVer";
import { RotatorObs } from "./Rotator/RotatorObs";
import { CannonObs } from "./Cannon/CannonObs";
import { GameWorld } from "../GameWorld";



export class ObstacleManager {
    /**
     * (RO) Staticky pristup
     */
    static get instance(): ObstacleManager { return ObstacleManager._instance; }
    private static _instance: ObstacleManager;

    /**
     * (RO) Verze prekazek [typ_prekazky][verze]
     */
    static get OBS_VERSIONS(): ObstacleVersion[][] { return ObstacleManager._OBS_VERSIONS; }
    private static _OBS_VERSIONS: ObstacleVersion[][];

    /**
     * Pooly s volnymi prekazmaki od jednotlivych typu [typ_prekazky]
     */
    private _freeObstacles: Pool<Obstacle>[][];

    /**
     * Seznam aktivnich prekazek
     */
    private _actObstacles: NodeList<Obstacle>;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor() {
        ObstacleManager._instance = this;

        // Popis verzi prekazek
        ObstacleManager._OBS_VERSIONS = [
            // Staticky typ prekazek
            [
                new ObstacleVersion(0, eModelAsset.obsColumn_0,
                    0,
                    [new ObstacleCollisionArea(new pc.BoundingBox(new pc.Vec3(0, 0.3, 0), new pc.Vec3(0.25, 0.3, 0.25)))], new pc.Vec3(0.25, 0.6, 0.25),
                    undefined,//new ObstacleShadow(eAtlas_0.shadowSquare, 1.5, 1.5, 0, GameWorld.SHADOW_Y, 0, true),
                    new ObstacleAnimation(eAnimAsset.showObsColumn_0, false, 9)),
                new ObstacleVersion(0, eModelAsset.obsGate_0,
                    0,
                    [
                        new ObstacleCollisionArea(new pc.BoundingBox(new pc.Vec3(-0.95, 0.4, 0), new pc.Vec3(0.225, 0.4, 0.2))),
                        new ObstacleCollisionArea(new pc.BoundingBox(new pc.Vec3(0.95, 0.4, 0), new pc.Vec3(0.225, 0.4, 0.2)))
                    ], new pc.Vec3(1.225, 0.8, 0.2),
                    new ObstacleShadow(eAtlas_0.shadowTunnel, 3, 1, 0, GameWorld.SHADOW_Y, 0, true)),
            ],
            // Posuvne prekazky
            [
                new ObstacleVersion(0, eModelAsset.obsWall_0,
                    0,
                    [new ObstacleCollisionArea(new pc.BoundingBox(new pc.Vec3(0, 0.5, 0), new pc.Vec3(0.5, 0.5, 0.5)))], new pc.Vec3(0.5, 1, 0.5)),
                new ObstacleVersion(1, eModelAsset.obsFlying_0,
                    0,
                    [new ObstacleCollisionArea(new pc.BoundingBox(new pc.Vec3(0, 0.3, 0), new pc.Vec3(0.33, 0.3, 0.33)))], new pc.Vec3(0.33, 0.6, 0.33),
                    new ObstacleShadow(eAtlas_0.shadowSquare, 1.1, 1.1, 0, GameWorld.SHADOW_Y, 0, false))
            ],
            // Pohyblive prekazky
            [
                new ObstacleVersion(0, eModelAsset.obsRolling_0,
                    0.45,
                    [new ObstacleCollisionArea(new pc.BoundingBox(new pc.Vec3(0, 0, 0), new pc.Vec3(0.4, 0.4, 0.15)))], new pc.Vec3(0.4, 0.4, 0.15),
                    new ObstacleShadow(eAtlas_0.shadowRect, 1.2, 0.7, 0, GameWorld.SHADOW_Y, 0.05, false))
            ],
            // Kladivo, ktere boucha vlevo/vpravo
            [
                new HammerObsVer(0.8, 0.2, pc.BounceIn)
            ],
            // Kladivo, ktere rotuje okolo osy Y
            [
                new RotatorObsVer(0.4, pc.BackOut, 0.1)
            ],
            // Delo
            [
                new ObstacleVersion(0, eModelAsset.laserCannon,
                    0,
                    [
                        new ObstacleCollisionArea(new pc.BoundingBox(new pc.Vec3(0, 0.45, 0.1), new pc.Vec3(0.2, 0.45, 0.2))),
                        new ObstacleCollisionArea(new pc.BoundingBox())
                    ],
                    new pc.Vec3(0.2, 0.9, 14),
                    new ObstacleShadow(eAtlas_0.shadowCircle, 1, 1, 0, GameWorld.SHADOW_Y, 0, true))
            ]
        ];

        // Pooly s volnymi prekazkami
        this._freeObstacles = [
            // Staticke prekazky
            [
                new Pool<Obstacle>(undefined, 4, true, (): Obstacle => { return new Obstacle(eObstacleType.static); }, this),
                new Pool<Obstacle>(undefined, 2, true, (): Obstacle => { return new Obstacle(eObstacleType.static); }, this)
            ],
            // Presunujici se prekazky
            [
                new Pool<ShiftingObstacle>(ShiftingObstacle, 6, true),
                new Pool<FlyingObstacle>(FlyingObstacle, 4, true)
            ],
            // Pohybujici se prekazky
            [
                new Pool<MovingObs>(MovingObs, 4, true)
            ],
            // Kladivo, ktere boucha vlevo/vpravo
            [
                new Pool<HammerObs>(HammerObs, 4, true)
            ],
            // Kladivo, ktere rotuje okolo osy Y
            [
                new Pool<RotatorObs>(RotatorObs, 4, true)
            ],
            // Delo
            [
                new Pool<CannonObs>(CannonObs, 2, true)
            ]
        ];

        // Seznam aktivnich prekazek
        this._actObstacles = new NodeList<Obstacle>();
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    reset(): void {
        // Uvolnit aktivni prekazky
        this._actObstacles.forEach((obs: Obstacle) => {
            this._freeObstacles[obs.type][obs.version.id].returnItem(obs);
            obs.release();
        });
        this._actObstacles.clear();
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(): void {
        // Volat update() pro aktivni prekazky
        this._actObstacles.forEach((obs: Obstacle, node: Node<Obstacle>) => {
            if (!obs.update()) {
                this._actObstacles.removeByNode(node);
                this._freeObstacles[obs.type][obs.version.id].returnItem(obs);
            }
        }, this);
    }

    //-------------------------------------------------------------------------
    /**
     * Aktivace prekazky
     * @param data 
     * @param row 
     */
    //-------------------------------------------------------------------------
    initObstacle(data: ObstacleMapData, row: ViewCellMapRow): void {
        let obs = this._freeObstacles[data.settings.type][data.settings.version].getItem();

        obs.init(data, row);
        this._actObstacles.add(obs);
    }
}